import React from 'react';

const CompletionTask = ({ title, icon, completed }) => (
  <div className="flex items-center justify-between p-3 border border-gray-100 rounded-lg">
    <div className="flex items-center">
      {icon}
      <span className="text-right font-medium mr-2">{title}</span>
    </div>
    <button className={`px-3 py-1 text-xs rounded-lg ${completed ? 'bg-green-100 text-green-800' : 'bg-blue-100 text-blue-800'}`}>
      {completed ? 'הושלם' : 'להשלמה'}
    </button>
  </div>
);

export default CompletionTask;